module.exports = __webpack_public_path__ + "static/media/exothermic.d2cf5717.webp";